// extracted by mini-css-extract-plugin
export default {"page":"PricingPlansStep_page__c+zIk","paid":"PricingPlansStep_paid__QIens","plans":"PricingPlansStep_plans__5rGDj","nativeNote":"PricingPlansStep_nativeNote__n9Os0"};